export default {
    createBlacklistText: 'สร้างบุคคลต้องห้าม',
    updateBlacklistText: 'แก้่ไขบุคคลต้องห้าม',
    name: 'ชื่อ',
    surname: 'นามสกุล',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    msgImageSize: 'ขนาดภาพต้องอยู่ระหว่าง 25KB ถึง 200KB',
    msgErrorImageSize: 'ขนาดของรูปภาพต้องอยู่ระหว่าง 25KB เเละ 200KB',
    msgError: 'เกิดข้อผิดพลาด',
    profile: 'ข้อมูลส่วนตัว',
    gender: 'เพศ',
    male: 'ชาย',
    female: 'หญิง',
    msgRequiredField: 'กรุณากรอกข้อมูล',
    msgExceededField: 'ข้อความเกิน 255 ตัวอักษร',
    reason: 'เหตุผล (ไม่จำเป็น)',
    writeReason: 'ระบุเหตุผล',
    status: 'สถานะ',
    errorNoImage: 'กรุณาใส่รูปภาพ'
}
